export { default } from './Boleto25BoletoVenceu';
